import { goRequestWithRecaptcha } from '../utils/httpClient';

export const getPaymentIntent = (data) =>
  goRequestWithRecaptcha('payment_intent', {
    url: '/payments/intent',
    method: 'POST',
    data: data,
  });

export const updatePaymentStatus = (data) =>
  goRequestWithRecaptcha('payment_intent_update', {
    url: '/payments/intent',
    method: 'PATCH',
    data: data,
  });
